"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimatedDeliveryDateImplementation = void 0;
var EstimatedDeliveryDateImplementation = /** @class */ (function () {
    function EstimatedDeliveryDateImplementation(request) {
        this.request = request;
    }
    /**
     * Batch predict the estimated delivery dates
     */
    EstimatedDeliveryDateImplementation.prototype.batchPredict = function (data) {
        // make request
        return this.request.makeRequest({
            method: 'POST',
            url: '/estimated-delivery-date/predict-batch',
        }, data);
    };
    return EstimatedDeliveryDateImplementation;
}());
exports.EstimatedDeliveryDateImplementation = EstimatedDeliveryDateImplementation;
